import type { ComplexTab } from "@/domains/navigation/components/complex-breadcrumb-dropdown"
import { CalendarIcon, ClockIcon, MergeIcon, RotateIcon, TransferIcon, WithdrawIcon } from "@/domains/icons"
import { IncreaseIcon } from "@/domains/icons/huge-icons/monotone/increase"
import { ResetLockIcon } from "@/domains/icons/huge-icons/monotone/reset-lock"
import { SwapIcon } from "@/domains/icons/huge-icons/monotone/swap"

import { VenammIcon } from "../icons/huge-icons/monotone/venamm"

export const MANAGE_LOCK_TABS: ComplexTab[] = [
  {
    id: "increase-amount-lock",
    label: "Increase Amount",
    tabLabel: "Increase",
    description: "Increase the amount of your lock",
    slug: "/increase-amount",
    icon: IncreaseIcon,
  },
  {
    id: "extend-duration-lock",
    label: "Extend Duration",
    tabLabel: "Extend",
    description: "Extend the duration of your lock",
    slug: "/extend-duration",
    icon: CalendarIcon,
  },
  {
    id: "merge-lock",
    label: "Merge veSCALE",
    tabLabel: "Merge",
    description: "Merge a lock into the current lock",
    slug: "/merge",
    icon: MergeIcon,
  },
  {
    id: "reset-lock",
    label: "Reset veSCALE",
    tabLabel: "Reset",
    description: "Reset your lock",
    slug: "/reset",
    icon: ResetLockIcon,
  },
  {
    id: "transfer-lock",
    label: "Transfer veSCALE",
    tabLabel: "Transfer",
    description: "Transfer your lock to another address",
    slug: "/transfer",
    icon: TransferIcon,
  },
  {
    id: "withdraw-lock",
    label: "Withdraw",
    tabLabel: "Withdraw",
    description: "Withdraw tokens from your lock",
    slug: "/withdraw",
    icon: WithdrawIcon,
  },
  {
    id: "venamm",
    label: "Venamm",
    tabLabel: "Venamm",
    description: "Sell your veSCALE for liquid tokens",
    slug: "/venamm",
    icon: VenammIcon,
  },
] as const
